import { range } from 'es-toolkit'

import { pageSize } from '../print-style'

import { Footer } from './footer'
import { Header } from './header'
import type { HeaderLabelTextConfig } from './header'
import type { ColumnConfig } from './main-row'
import { MainRow } from './main-row'

// v1 apps/frontend/client/src/components/MillsheetPrintForm/MillsheetListSvgV2/MillsheetListSvgV2.tsx の移植（そのまま）。
// svg を tsx 化した帳票コンポーネント。座標はすべて Figma のデザインに合わせた絶対値のため、
// 見た目を変えない限り数値には触れない

export type Item = {
  steelType: string | null
  sectionType: string | null
  size: string | null
  thicknessDiameter: string | null
  length: string | null
  quantity: string | null
  weight: string | null
  heatNumber: string | null
  individualNumber: string | null
  no: string | null
  manufacturerName: string | null
  constructionArea: string | null
  member: string | null
  buildingPart: string | null
  memo: string | null
  // 発注照合の集計表では「2-1」のような枝番形式の文字列も入る（assignSummaryPageNumbers）
  pageNumber: number | string | null
  tradingCompany: string | null
  orderNumber: string | null
  innerNo: string | null
  // 発注照合の「鋼材ミルシート集計表」でのみ使う列
  endorsementCompany?: string | null
  // ホームの Excel（使用鋼材一覧表）でのみ使う列。裏書日1（YYYY-MM-DD）
  endorsementDate?: string | null
  // 裏書の階層2〜6。Excel の「すべての裏書情報を含める」でのみ使う
  // （階層1は endorsementCompany / endorsementDate。集計処理が Item を単純な値のレコードとして扱うため配列にはしない）
  endorsementCompany2?: string | null
  endorsementDate2?: string | null
  endorsementCompany3?: string | null
  endorsementDate3?: string | null
  endorsementCompany4?: string | null
  endorsementDate4?: string | null
  endorsementCompany5?: string | null
  endorsementDate5?: string | null
  endorsementCompany6?: string | null
  endorsementDate6?: string | null
  customer?: string | null
  referenceNumber?: string | null
  // 発注データ（SteelOrder）由来の列。ミルシート側には無い項目のためオプショナル
  supplierName?: string | null
}

// 1ページ分の body 行数。SLICE_NUMBER と同じく 18 行を意図しているが、下の
// `range(0, ITEM_SHOULD_LENGTH - items.length + 1)` の range が end exclusive のため、
// ITEM_SHOULD_LENGTH を 17 にしておかないと埋め行が 1 行余計に出力され、Footer 文字列と
// body の最下行が重なってしまう（v1 での既知の落とし穴。コメントごと移植）
const ITEM_SHOULD_LENGTH = 17
export const MillsheetListSvgV2 = ({
  items,
  date,
  sumKg,
  constructionName,
  indexStart,
  columnConfigs,
  headerLabelTextConfig,
  asSummary,
}: {
  items: Item[]
  date: string
  sumKg: string
  constructionName: string
  indexStart: number
  columnConfigs: ColumnConfig[]
  headerLabelTextConfig: HeaderLabelTextConfig
  asSummary: boolean
}) => {
  const itemsWithEmpty: Item[] = [
    ...items,
    ...range(0, ITEM_SHOULD_LENGTH - items.length + 1).map((): Item => ({
      steelType: null,
      sectionType: null,
      size: null,
      thicknessDiameter: null,
      length: null,
      quantity: null,
      weight: null,
      heatNumber: null,
      individualNumber: null,
      no: null,
      manufacturerName: null,
      constructionArea: null,
      member: null,
      buildingPart: null,
      memo: null,
      pageNumber: null,
      tradingCompany: null,
      orderNumber: null,
      innerNo: null,
    })),
  ]
  return (
    <svg
      width={pageSize.width}
      height={pageSize.height}
      viewBox="0 0 1050 1486"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="millsheet_list_v2">
        <rect width={1050} height={1485.15} fill="white" />
        <rect x={95} y={220} width={860} height={1080} stroke="black" strokeWidth={2} />
        <Header
          constructionName={constructionName}
          sumKg={sumKg}
          columnConfigs={columnConfigs}
          headerLabelTextConfig={headerLabelTextConfig}
          asSummary={asSummary}
        />
        {itemsWithEmpty.map((item, index) => (
          <MainRow key={index} item={item} index={index} indexStart={indexStart} columnConfigs={columnConfigs} />
        ))}
        <Footer columnConfigs={columnConfigs} />
      </g>
    </svg>
  )
}
